import {
  formatClassNames,
  getDataAttributes,
} from '@wix/editor-elements-common-utils';
import classNames from 'clsx';
import React, { useRef } from 'react';

import semanticClassNames from '../SocialPlayerVimeo.semanticClassNames';
import type { ISocialPlayerVimeoProps } from '../SocialPlayerVimeo.types';
import styles from './SocialPlayerVimeo.module.scss';
import { useVimeoPlayer } from './hooks/useVimeoPlayer';

const SocialPlayerVimeo: React.FC<ISocialPlayerVimeoProps> = ({
  id,
  className,
  customClassNames = [],
  url,
  description,
  autoPlay = false,
  loop = false,
  mute = false,
  enabledTitle = true,
  startTime,
  endTime,
  onMouseEnter,
  onMouseLeave,
  ...props
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useVimeoPlayer({
    url,
    autoPlay,
    loop,
    mute,
    enabledTitle,
    startTime,
    endTime,
    ref,
  });

  return (
    <div
      id={id}
      className={classNames(
        styles.root,
        className,
        formatClassNames(semanticClassNames.root, ...customClassNames),
      )}
      aria-label={description}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...getDataAttributes(props)}
    >
      <div className={styles.playerWrapper}>
        <div ref={ref} className={styles.alignmentWrapper} />
      </div>
    </div>
  );
};

export default SocialPlayerVimeo;
